module.exports = __webpack_public_path__ + "img/abgc11.1f6a1477.jpg";